import { Button } from 'shared/components/Button/Button'
import { TextV2 } from 'shared/components/Text/TextV2'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

export function isFleetOperationalPath(path: string, isDriver = false, canViewMetrics = false) {
  if (/^\/(?:jobs|search|saved-loads|contacted-loads|external-book|loads)(?:\/|$)/.test(path)) return true
  if (/^\/(?:issues|inbox|chats|market-conditions|fleet\/(?:members|equipment))\/?$/.test(path)) return true
  if (/^\/issues\/inbox\/?$/.test(path)) return true
  if (/^\/my-performance\/?$/.test(path)) return canViewMetrics
  return (
    isDriver &&
    (/^\/(?:driver-screening-consent|driver-onboarding|cdl-upload)(?:\/|$)/.test(path) ||
      /^\/ct-cash\/account-activity(?:\/|$)/.test(path) ||
      /^\/profile\/?$/.test(path))
  )
}

export function FleetAdministrationNotice({ path }: { path: string }) {
  let destination = '/company/'
  if (/equipment|truck|trailer/.test(path)) destination = path.includes('trailer') ? '/trailers/' : '/trucks/'
  else if (path.includes('broker')) destination = '/brokers/'
  else if (/^\/(?:onboarding|add-|user|deactivate)|fleet-members/.test(path)) destination = '/users/'
  return (
    <div className="mx-auto flex max-w-xl flex-col gap-6 p-8">
      <TextV2 type={TYPOGRAPHY.header2}>Manage your company</TextV2>
      <TextV2>Open company administration for settings, onboarding, users, and equipment changes.</TextV2>
      <Button href={`/manage${destination}`}>Open company administration</Button>
      <Button href="/jobs/" variant="secondary">
        Return to fleet
      </Button>
    </div>
  )
}
